import { MSG_CAMPO_INVALIDO, MSG_CAMPO_OBRIGATORIO } from 'utils/consts';
import { isRequired } from 'utils/validate/validate';

export const validationsCreateUpdate = dadosInputs => {
  const { nomePosto, endereco, telefone, diasHorariosAtendimentos, solicitacaoIds } = dadosInputs;
  const errosCampos = {
    nomePosto: null,
    endereco: null,
    telefone: null,
    diasHorariosAtendimentos: null,
    solicitacaoIds: null,
  };

  errosCampos.nomePosto = isRequired(nomePosto);
  errosCampos.endereco = isRequired(endereco);
  errosCampos.diasHorariosAtendimentos = isRequired(diasHorariosAtendimentos);
  errosCampos.solicitacaoIds = isRequired(solicitacaoIds);
  if (telefone?.length > 0 && telefone?.length < 10) errosCampos.telefone = MSG_CAMPO_INVALIDO;
  errosCampos.solicitacaoIds = solicitacaoIds?.length === 0 ? MSG_CAMPO_OBRIGATORIO : null;
  return errosCampos;
};
